import * as React from 'react';

import { TouchableOpacityProps, TouchableOpacity, View, ViewProps } from 'react-native';

import { DEFAULT_ELEVATION } from './sizes';
import { getShadow } from './utils';

/**
 * Base component for all cards (based off of Google Material UI design principles).
 *
 * @param props - Card Base Props.
 */
export function CardBase(props: CardBaseProps) {
  const {
    disabled,
    elevation = DEFAULT_ELEVATION,
    style,
    children,
    onPress,
    ...otherProps
  } = props;
  const shadowStyle = elevation ? getShadow(elevation) : undefined;
  const isDisabled = disabled === undefined ? !onPress : disabled;

  return (
    <View style={[style, shadowStyle]}>
      <TouchableOpacity disabled={isDisabled} onPress={onPress} {...otherProps}>
        {children}
      </TouchableOpacity>
    </View>
  );
}
type CardBaseProps = WithChildren<TouchableOpacityProps & ViewProps & { elevation?: number }>;
